<template>
    <div>
        <!--type date-->
        <v-menu
            ref="datePicker"
            v-model="showDatePicker"
            :close-on-content-click="false"
            :nudge-top="-8"
            transition="scale-transition"
            offset-y
            max-width="290px"
            min-width="290px"
            v-if="type === 'date'"
        >
            <template v-slot:activator="{ on, attrs }">
                <div :style="{width: `${width ? width : 150}px`}" style="position: relative">
                    <v-text-field
                        v-model="dateTime"
                        :label="label"
                        prepend-icon=""
                        v-bind="attrs"
                        v-on="on"
                        :rules="rules ? rules : []"
                        class="input-custom"
                    ></v-text-field>
                    <img src="/img/calendar.svg" class="icon-inner" v-bind="attrs" v-on="on" alt="icon-date"/>
                </div>
            </template>
            <v-date-picker
                v-model="dateTime"
                :color="color"
                :min="min"
                :max="max"
                @click:date="$refs.datePicker.save(dateTime)"
            ></v-date-picker>
        </v-menu>
        <!--type time-->
        <v-menu
            ref="timePicker"
            v-model="showTimePicker"
            :close-on-content-click="false"
            :nudge-top="-8"
            transition="scale-transition"
            offset-y
            max-width="290px"
            min-width="290px"
            v-if="type === 'time'"
        >
            <template v-slot:activator="{ on, attrs }">
                <div :style="{width: `${width ? width : 150}px`}" style="position: relative">
                    <v-text-field
                        v-model="dateTime"
                        :label="label"
                        class="input-custom"
                        v-bind="attrs"
                        v-on="on"
                        :rules="rules ? rules : []"
                    ></v-text-field>
                    <img src="/img/clock.svg" class="icon-inner" v-bind="attrs" v-on="on" alt="icon-time"/>
                </div>
            </template>
            <v-time-picker
                v-if="showTimePicker"
                v-model="dateTime"
                :format="format ? format : '24hr'"
                :color="color"
                :min="min"
                :max="max"
                @click:minute="$refs.timePicker.save(dateTime)"
                :use-seconds="useSeconds"
                class="aaa"
            ></v-time-picker>
        </v-menu>
    </div>
</template>

<script>
export default {
    name: 'DateTimeInput',
    props: {
        value: String,
        label: String,
        width: Number,
        type: String, // 'date' or 'time',
        format: String, // 'ampm' or '24hr'
        color: String,
        min: String,
        max: String,
        rules: Array,
        useSeconds: Boolean
    },
    data() {
        let today = this.$moment().format('YYYY-MM-DD')
        return {
            today: today,
            dateTime: null,
            showDatePicker: false,
            showTimePicker: false,
        }
    },
    mounted() {
        this.dateTime = this.value
    },
    watch: {
        value(value) {
            this.dateTime = value
        },
        dateTime(val) {
            this.$emit('input', val)
        }
    }
}
</script>

<style scoped lang="scss">
.input-custom {
    position: relative;
    height: 32px;
    background: #FFFFFF;
    border-radius: 5px;
    outline: none;
    font-size: 14px;
    padding: 0;
    margin: 0;
    display: flex;
    align-items: center;

    &.v-input--is-focused {
        border-color: #0052cc;
    }

    ::v-deep * {
        cursor: pointer;

        &:before, &:after {
            border: none !important;
        }

        .v-select__selections {
            white-space: nowrap;

            ::v-deep {
                cursor: pointer;
            }
        }

        .v-label {
            background: #FFFFFF;
            padding: 0 4px;
            left: 6px !important;

            &:not(.v-label--active) {
                font-size: 14px;
            }
        }

        input {
            font-size: 14px;
        }
    }
}

.icon-inner {
    position: absolute;
    top: 9px;
    right: 12px;
    transform: scale(1.2);
    cursor: pointer;
}

::v-deep {
    .v-card {
        border-radius: 5px !important;
    }

    .v-text-field__details {
        position: absolute;
        right: 32px !important;
        top: 8px !important;
    }
}
</style>
